/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 23-09-2026
 *
 * Waarmee een applicatie de `TaalService` vertelt welke talen hij aanbiedt. Admin en material hebben
 * er drie, create zes; de service hoort dat niet te weten. Beide tokens hebben een standaardwaarde,
 * dus een applicatie die niets bindt houdt precies het gedrag van vóór deze splitsing.
 *
 * Een applicatie bindt ze in zijn `app.config.ts`:
 *   {provide: TALEN_TOKEN, useValue: ['en', 'nl', 'de', 'fr', 'pt-BR', 'el']}
 *   {provide: TAALALIASSEN, useValue: {pt: 'pt-BR'}}
 */
import {InjectionToken} from '@angular/core';
import {TALEN, type Taalcode} from '../types';

/**
 * De talen waarin deze applicatie beschikbaar is; de eerste geldt als terugval. De standaard is de
 * lijst van de backoffice-applicaties.
 */
export const TALEN_TOKEN = new InjectionToken<readonly Taalcode[]>('TALEN', {
    providedIn: 'root',
    factory: () => TALEN
});

/**
 * Taalcodes die op een andere taal uitkomen, toegepast vóórdat er gekeken wordt of de taal bestaat.
 * Nodig omdat de browsertaal een regiovariant terugbrengt tot zijn basistaal: een Braziliaanse
 * browser levert `pt`, en create biedt alleen `pt-BR` aan. Zonder deze tabel valt zo'n bezoeker
 * terug op de terugvaltaal.
 */
export const TAALALIASSEN = new InjectionToken<Readonly<Record<string, Taalcode>>>('TAALALIASSEN', {
    providedIn: 'root',
    factory: () => ({})
});
